export default {
    backText: 'Nazad na kolekcije',
    title: 'Dodaj kolekciju',
    editTitle: 'Izmijeni kolekciju',
    search: 'Pretraži proizvode',
    image: 'Fotografija',
    successEditMessage: 'Kolekcija je uspješno izmijenjena.',
    details: {
        title: 'Detalji kolekcije',
        collectionTitle: {
            title: 'Naziv',
            placeholder: 'Unesite naziv'
        },
        description: {
            title: 'Opis (opciono)',
            placeholder: 'Unesite opis'
        }
    },
    button: {
        add: 'Dodaj kolekciju',
        update: 'Izmijeni kolekciju',
        cancel: 'Poništi'
    },
    products: {
        title: 'Proizvodi',
        subtitle: 'Dodajte proizvode u kolekciju',
        addProduct: 'Dodaj proizvod',
        emptyCollection: 'U Vašoj kolekciji trenutno nema proizvoda.'
    },
    activity: {
        status: 'Kolekcija je aktivna.',
        status2: 'Kolekcija je neaktivna.',
        description:
            'Aktivne kolekcije su vidljive u prodavnici. Aktivnost kolekcije se može mijenjati i nakon njenog dodavanja.'
    },
    addProductModal: {
        cancel: 'Poništi',
        addProducts: 'Dodaj proizvode',
        add: 'Dodaj',
        paginatorText: 'proizvoda'
    }
};
